import type { ImageElement } from '@/components/canvas/document/publicTypes';
import { type BaseElementConfig, createBase } from '../registry/factoryShared';

export function createImageElement(
  config: BaseElementConfig & {
    src: string;
    objectFit?: ImageElement['data']['objectFit'];
    objectPosition?: ImageElement['data']['objectPosition'];
    imageScale?: number;
  },
): ImageElement {
  return {
    ...createBase('image', config),
    data: {
      src: config.src,
      objectFit: config.objectFit ?? 'cover',
      objectPosition: config.objectPosition,
      imageScale: config.imageScale,
    },
  };
}
